import { useEffect, useState } from "react";
import { Delete } from "lucide-react";

export const PinPad = ({ value, onChange, onComplete }) => {
  const press = (d) => {
    if (value.length >= 4) return;
    const next = value + d;
    onChange(next);
    if (next.length === 4 && onComplete) onComplete(next);
  };
  const back = () => onChange(value.slice(0, -1));

  useEffect(() => {
    const handler = (e) => {
      if (e.key >= "0" && e.key <= "9") press(e.key);
      else if (e.key === "Backspace") back();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  });

  return (
    <div className="w-full max-w-xs mx-auto" data-testid="pin-pad">
      <div className="flex justify-center gap-3 mb-4">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            data-testid={`pin-dot-${i}`}
            className={`w-4 h-4 rounded-full border-2 transition-colors duration-150 ${
              value.length > i ? "bg-red-600 border-red-600" : "border-slate-400"
            }`}
          />
        ))}
      </div>
      <div className="grid grid-cols-3 gap-2 sm:gap-3">
        {["1", "2", "3", "4", "5", "6", "7", "8", "9"].map((d) => (
          <button
            key={d}
            type="button"
            data-testid={`pin-key-${d}`}
            onClick={() => press(d)}
            className="h-14 text-2xl font-mono font-semibold rounded-sm bg-white border border-slate-300 hover:bg-slate-100 active:bg-slate-200 transition-colors duration-150"
          >
            {d}
          </button>
        ))}
        <div />
        <button
          type="button"
          data-testid="pin-key-0"
          onClick={() => press("0")}
          className="h-14 text-2xl font-mono font-semibold rounded-sm bg-white border border-slate-300 hover:bg-slate-100 active:bg-slate-200 transition-colors duration-150"
        >
          0
        </button>
        <button
          type="button"
          data-testid="pin-key-back"
          onClick={back}
          className="h-14 rounded-sm bg-slate-100 border border-slate-300 hover:bg-slate-200 flex items-center justify-center transition-colors duration-150"
        >
          <Delete className="w-6 h-6 text-slate-700" />
        </button>
      </div>
    </div>
  );
};

export const usePin = () => useState("");
